module.exports = __webpack_public_path__ + "img/图层 1495 拷贝.aa210d5c.png";